'use strict';


var Emitter = require('cjs-emitter');


function Section ( config ) {
    var keys     = Object.keys(config),
        keysSize = keys.length,
        index    = 0,
        events   = config.events,
        event;

    while ( index < keysSize ) {
        this[keys[index]] = config[keys[index]];
        ++index;
    }

    /*
     * this.saveImmediate;
     * this.requirePortalReboot;
     * this.requireDeviceReboot;
     */

    this.events = {};

    Emitter.call(this, config);

    for ( event in events ) {
        this.addListener(event, events[event]);
    }

    this.render = require('../renders/list.item');

    this.type = 'section';
    this.advanced = !!config.advanced;
}


// inheritance
Section.prototype = Object.create(Emitter.prototype);
Section.prototype.constructor = Section;


module.exports = Section;
